import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import useRequest from 'hooks/useRequest';
import { useEffect } from 'react';

interface VetInfo {
  approveAccess: boolean;
  fullName: string;
  identification: string;
  imageUrl: string;
  organization: string;
  supplierName: string;
  vetType: 1 | 2;
  providerInquiryAccess: boolean;
  loadInquiryAccess: boolean;
}

function useVetInfo() {
  const [_, result] = useFetchCallType<VetInfo>('GetVetInfo');

  return result;
}

export default useVetInfo;
